<template>
  <div class="monit-page">
    <div class="monit-main row justify-content-sb">
      <h3 v-if="mobile" class="page-title col-xs-12 col-sm-6 pt-2">
        Monitore dispositivos
      </h3>
      <toolbar
        v-if="mobile"
        class="col-xs-12 col-sm-6"
        type="dirs"
        :is-mobile="mobile"
        :filter-opt="filterOpt"
        :is-filtering="isFiltering"
        @filter-by="onFilterBy"
        :type-filtering="
          tab1.toLowerCase() === 'exibir todos' ? '' : tab1.toLowerCase()
        "
        @search="searchBy"
        @clear-search="onClearSearch"
        @reset="resetProp"
        :is-searching="isSearching"
        :filters="filters"
        :types-options="options"
        :filter-tag="filterBy === 100 ? true : false"
        @type-change="changeTypeMobile"
        :not-exists="showErrorNotFound"
        :not-search="showErrorNotSearch"
        ref="INP"
      />

      <div v-if="loading" class="col-xs-12 center-xs mt-2">
        <spinner /> Aguarde...
      </div>
      <div
        v-if="showErrorNotSearch && !showErrorNotFound"
        class="EmptyRequest row center-xs mx-2 md-12 w-100 p-0 mt-3"
        style="text-align: left"
      >
        <img :src="searchIcon" class="empty" />
        <span>
          Não foi possível realizar a busca,
          <b-link @click="resetSearch"> clique aqui </b-link> para voltar a
          exibir os dispositivos.</span
        >
      </div>

      <div
        v-if="showErrorNotFound"
        class="EmptyRequest w-100 p-0 row center-xs center-md center-sm center-xs mt-3"
      >
        <img :src="emptyIcon" class="empty" />
        <span
          >Não há dispositivos para exibir. Para cadastrar um novo,
          <router-link to="/registers/devices">clique aqui</router-link></span
        >
      </div>

      <!-- CARDS -->
      <div class="container-cards">
        <div
          v-for="(item, index) in orderedList"
          :key="index"
          class="dir-space-card"
        >
          <router-link
            :to="`/monitoring/dirs/`"
            @click.native="
              () => {
                openDetailsDialog(item);
                selectedCard = index;
              }
            "
          >
            <div
              :class="`monitCard ${setBGBody(item.RF.stat)} ${
                selectedCard == index ? 'activeCard' : ''
              }`"
            >
              <div :class="`top ${setBG(item.RF.stat)}`"></div>
              <div class="monit-name" v-if="regexMTD.test(item.MODEL)">
                <span>{{ item.NAME }}</span>
                <span v-if="!mobile"> - {{ item.MODEL }}</span>
              </div>
              <div class="monit-name" v-else>
                {{ item.ID }}
                <span>- {{ item.MODEL }}</span>
              </div>

              <div class="info">
                <!-- <span>Sinal:</span> -->
                <div class="percent-card">
                  <wifi-icon title="Sinal" />
                  <span>Sinal:</span>
                  <span>
                    {{
                      item.RF && item.RF.ack && item.RF.ack.length == 2
                        ? calculatePercentage(item.RF.ack[0], item.RF.ack[1]) +
                          "%"
                        : "Sem sinal"
                    }}
                  </span>
                </div>
                <div class="BAT">
                  <battery-outline-icon title="Bateria" />
                  <span>Bateria: </span>
                  <span>{{
                    item.BAT ? item.BAT + " V" : "Sem informações"
                  }}</span>
                </div>
                <div class="rssi" v-if="getRSSI(item)">
                  <span>RSSI: </span>
                  <span>{{ getRSSI(item) }}</span>
                </div>
              </div>

              <footer>
                <div id="date">{{ formatUpdate(item.UPDATE) }}</div>
                <div :class="`status ${setBG(item.RF.stat)}`">
                  {{ selectInfoStatus(item.RF.stat) }}
                </div>
              </footer>
            </div>
          </router-link>
        </div>
      </div>
    </div>

    <!-- BARRA DA DIREITA -->
    <div class="monit-helper" v-if="!mobile">
      <div class="container-helper">
        <header>
          <div class="header-group">
            <dir-icon title="" customHeight="20px" />
            <div class="title-monit-helper">Monitore dispositivos</div>
          </div>
          <toolbar
            v-if="!mobile"
            class="toolbar"
            type="dirs"
            :is-mobile="mobile"
            :filter-opt="filterOpt"
            :is-filtering="isFiltering"
            @filter-by="onFilterBy"
            @search="searchBy"
            @clear-search="onClearSearch"
            :is-searching="isSearching"
            :type-filtering="
              tab1.toLowerCase() === 'exibir todos' ? '' : tab1.toLowerCase()
            "
            :not-exists="showErrorNotFound"
            :not-search="showErrorNotSearch"
          />
        </header>
        <!-- <br /> -->
        <div class="filter-container mt-2">
          <div class="col-xs-12 filter-title">
            <h5>Dispositivos</h5>
            <span>{{ orderedList.length }}</span>
          </div>
          <div class="label ml-2 mr-2 mt-3" v-if="!mobile">
            Filtrar por modelo:
          </div>
          <div class="filter-model col-xs-12 ml-2 mr-2 mt-0 mb-0">
            <b-form-group v-if="!mobile" class="mb-0">
              <b-form-checkbox-group
                id="checkbox-group-1"
                v-model="selectedCheckbox"
                :options="options"
                name="filters"
                button-variant="info"
                size="sm"
              ></b-form-checkbox-group>
            </b-form-group>
          </div>
          <div class="label ml-2 mr-2 mb-2 mt-3" v-if="!mobile">
            Filtrar por comunicação:
          </div>
          <b-form-radio-group
            label="Filtro por comunicação: "
            v-model="selectedRadiusButton"
            buttons
            button-variant="light"
            size="md"
          >
            <div class="col-12">
              <b-form-radio name="Exibir todos" :value="null">
                Exibir todos</b-form-radio
              >
              <b-form-radio name="Comunicando" :value="0">
                <!-- Comunicando -->
                Comunicando ({{ alerts[0].length }})
              </b-form-radio>
              <b-form-radio name="Timeout" :value="7">
                <!-- Perdendo sinal -->
                Perdendo sinal ({{ alerts[7].length }})
              </b-form-radio>
              <b-form-radio name="Falha 1" :value="8">
                <!-- Falha 1 -->
                Falha 1 ({{ alerts[8].length }})
              </b-form-radio>
              <b-form-radio name="Falha 2" :value="9">
                <!-- Falha 2 -->
                Falha 2 ({{ alerts[9].length }})
              </b-form-radio>
            </div>
          </b-form-radio-group>
        </div>
      </div>
    </div>

    <dirs-details
      :item="selected"
      :my-time="
        Object.keys(selected).length && selected.RF
          ? { n1: selected.RF.ack[0], n2: selected.RF.ack[1] }
          : {}
      "
      :status-color="variant"
      :updated="updated"
      :variant="variant"
      :show-details="showDetails"
      :is-mobile="mobile"
      :success-percentage="
        Object.keys(selected).length &&
        selected.RF &&
        calculatePercentage(selected.RF.ack[0], selected.RF.ack[1])
      "
      @close-details="closeDetails"
    />
  </div>
</template>

<script>
import { monitSignal, updateFormatter } from "@/pages/components/helpers";
import EventBus from "@/pages/components/eventBus";
import { monit } from "@/api";
export default {
  name: "monit-dirs",
  props: {
    mobile: Boolean,
  },
  created() {
    this.$emit(
      "title-change",
      this.mobile ? "M. de DIRs" : "Monitoramento de DIRs"
    );
    // Com o AbortController eu consigo abortar as requisições quando e onde quiser
    this.controller = new AbortController();

    this.monitLoop();
    this.selectedRadiusButton = null;
    if (!this.type) {
      this.tab1 = "EXIBIR TODOS";
    }
    console.log(this.searchBy);
  },
  data() {
    return {
      showDetails: false,
      tab1: "",
      tab2: "",
      type: null,
      emptyIcon: require("../../../assets/icons/Empty.svg"),
      searchIcon: require("../../../assets/icons/search.svg"),
      list: [],
      fullList: [],
      backendNow: null,
      loading: true,
      selected: {},
      selectedCard: null,
      filterBy: 100,
      missingResults: false,
      isSearching: false,
      isFiltering: false,
      filter: "",
      filterOpt: "",
      checkboxList: [],
      selectedCheckbox: [],
      selectedRadiusButton: "",
      options: [],
      filters: [
        { text: "Comunicando", value: 0 },
        { text: "Timeout", value: 7 },
        { text: "Falha 1", value: 8 },
        { text: "Falha 2", value: 9 },
      ],
      items: [],
      controller: null,
      timeout: null,
      regexMTD: new RegExp("MTD"),
      alerts: {
        0: [],
        7: [],
        8: [],
        9: [],
      },
      showErrorNotFound: false,
      showErrorNotSearch: false,
      myTime: "",
    };
  },
  beforeDestroy() {
    this.controller.abort();
    clearTimeout(this.timeout);
  },
  watch: {
    selectedCheckbox() {
      if (!this.mobile) {
        this.isActive(this.items);
      }
    },
    selectedRadiusButton(v) {
      if (v != null) {
        this.onFilterBy(v);
      } else {
        this.showErrorNotSearch = false;
        this.onFilterBy(100);
      }
    },
    mobile(newValue, oldValue) {
      if (newValue) {
        this.showErrorNotSearch = false;
        this.showErrorNotFound = false;
        this.selectedRadiusButton = null;
        this.selectedCheckbox = [];
        this.isSearching = false;
        this.filter = "";
      } else {
        this.resetSearch();
      }
    },
  },
  methods: {
    selectCard(item, index) {
      this.selectedCard = index;
      openDetailsDialog(item);
    },
    closeDetails() {
      this.showDetails = false;
      this.selectedCard = null;
      this.selected = {};
    },
    resetSearch() {
      this.selectedCheckbox = [];
      this.selectedRadiusButton = null;
      EventBus.cleanInputSearch();
      this.filter = "";
      // this.resetDropdown();
      this.isSearching = false;
      this.items = this.fullList;
      this.showErrorNotSearch = false;
      this.resetProp();
      this.resetDropdown();
      this.clearSearchInput();
    },
    onClearSearch() {
      this.filter = "";
      this.resetDropdown();
    },
    selectDropdownItem(option) {
      this.type = option;
      this.clearSearchInput();
    },
    changeTypeMobile(t) {
      this.type = t;
    },
    resetProp() {
      this.onFilterBy(100);
    },
    getRSSI(item) {
      if (item.GENERIC && item.GENERIC.length) {
        let filtered = item.GENERIC.filter((e) => e.NAME == "RSSI¹:")[0];
        if (filtered) {
          return filtered.VALUE;
        }
      }
    },
    isActive(result) {
      let dirs = [];
      const regexMTD = new RegExp("MTD");
      if (
        !this.mobile &&
        !!this.selectedCheckbox &&
        this.selectedCheckbox.length > 0
      ) {
        this.isFiltering = false;
        dirs = this.isSearchDropdown(result);
        if (result.length) {
        }
      } else if (
        !this.mobile &&
        !!this.selectedCheckbox &&
        !this.selectedCheckbox.length
      ) {
        this.tab1 = "EXIBIR TODOS";
        this.title = "ALL";
        this.isFiltering = false;
        dirs = this.fullList;
      } else if (!this.mobile) {
        this.selectedRadiusButton = null;
        this.selectedCheckbox = [];
        this.tab1 = "EXIBIR TODOS";
        this.title = "ALL";
        this.isFiltering = false;
        dirs = this.fullList;
      } else if (this.mobile && this.type && !regexMTD.test(this.type)) {
        this.tab1 = this.type;
        this.title = "DIR";
        // this.clearSearch();
        if (result.length) {
          dirs = this.isSearchDropdown(result);
        }
      }
      // Quando for MTD
      else if (this.mobile && this.type && regexMTD.test(this.type)) {
        this.tab1 = this.type;
        this.title = "MTD";
        if (result.length) {
          dirs = this.isSearchDropdown(result);
        }
      } else if (this.mobile && !this.type) {
        this.showErrorNotSearch = false;
        this.selectedRadiusButton = null;
        this.selectedCheckbox = [];
        this.tab1 = "EXIBIR TODOS";
        this.title = "ALL";
        this.isFiltering = false;
        dirs = this.fullList;
      }
      return dirs;
    },
    isSearch(result) {
      let filter;
      filter = result.filter((item) => {
        if (item.MODEL !== "MTD" && item.ID.indexOf(this.filter) > -1) {
          return true;
        }
        if (item.MODEL === "MTD" && item.NAME.indexOf(this.filter) > -1) {
          return true;
        }
        if (item.MODEL && item.MODEL.indexOf(this.filter) > -1) {
          return true;
        }
        if (item.MODEL_NAME && item.MODEL_NAME.indexOf(this.filter) > -1) {
          return true;
        }
      });
      if (filter.length) {
        this.showErrorNotSearch = false;
        return filter;
      } else {
        this.showErrorNotSearch = true;
        return [];
      }
    },
    isSearchDropdown(result) {
      if (this.mobile) {
        let filter;
        filter = result.filter((item) => item.MODEL == this.type);
        if (filter.length) {
          this.showErrorNotSearch = false;
          return filter.sort((a, b) => a.ID - b.ID);
        } else {
          this.showErrorNotSearch = true;
          return [];
        }
      } else {
        let results = [];
        for (let checkbox of this.selectedCheckbox) {
          let filter = result.filter((item) => item.MODEL == checkbox);
          results.push(...filter);
        }
        if (results.length) {
          this.showErrorNotSearch = false;
          return results.sort((a, b) => a.ID - b.ID);
        } else {
          this.showErrorNotSearch = true;
          return [];
        }
      }
    },
    monitLoop() {
      monit
        .dir(this.controller)
        .then((res) => {
          this.backendNow = Date.parse(res.headers.get("date"));
          return res.json();
        })
        .then((ret) => {
          let list = ret;
          this.loadFilterModels(ret);
          this.fullList = list;
          // Se tiver pesquisando, se o filtro for válido e tiver items
          if (this.isSearching && this.validFilter && list.length) {
            this.items = this.isSearch(list);
          } else this.items = list;
          if (this.loading) this.loading = false;
          if (
            Object.keys(this.selected).length &&
            this.selected.ID &&
            list.length
          ) {
            this.selected =
              list.filter((e) => e.ID == this.selected.ID)[0] || this.selected;
          }
          return;
        })
        .catch((err) => {
          return err.name;
        })
        .then((_) => {
          if (!this.loading && !this.items.length && !this.showErrorNotSearch) {
            this.showErrorNotFound = true;
          } else {
            this.showErrorNotFound = false;
          }
        })
        .then((ret) => {
          if (ret !== "AbortError") {
            this.timeout = setTimeout(this.monitLoop, 2000);
          }
        });
    },
    formatUpdate(update) {
      this.myTime = updateFormatter(update);
      return updateFormatter(update);
    },
    setBG(stat) {
      switch (stat) {
        case 0:
          return "bg-3v3";
        case 7:
          return "bg-yellow";
        case 8:
          return "bg-red";
        case 9:
          return "bg-black";
        default:
          return "bg-grey";
      }
    },
    selectInfoStatus(stat) {
      switch (stat) {
        case 0:
          return "COMUNICANDO";
        case 7:
          return "TIMEOUT";
        case 8:
          return "FALHA";
        case 9:
          return "FALHA";
        default:
          return "bg-grey";
      }
    },
    setBGBody(stat) {
      switch (stat) {
        case 0:
          return "";
        case 7:
          return "";
        case 8:
          return "bg-red-body";
        case 9:
          return "bg-black-body";
        default:
          return "";
      }
    },
    resetDropdown() {
      this.type = null;
      this.tab1 = "EXIBIR TODOS";
      this.isSearching = false;
      this.showErrorNotSearch = false;
      this.items = this.fullList;
    },
    searchBy(addr) {
      console.log(addr);
      this.isSearching = !!addr.split(" ").join("");
      // if (!this.selectedRadiusButton) {
      // }
      this.filter = addr;
    },
    clearSearch() {
      if (!!this.$children[0] && this.$children[0].length > 0) {
        this.$children[0].clearText();
      }
      this.isSearching = false;
      this.missingResults = false;
    },
    clearSearchInput() {
      if (!!this.$children[0] && this.$children[0].length > 0) {
        this.$children[0].clearText();
      }
      this.isSearching = false;
      this.items = this.fullList;
    },
    onFilterBy(value) {
      // if (value == 100) this.clearSearch();
      this.isFiltering = value != 100;
      if (value.text) {
        this.filterOpt = value.text;
      }
      this.filterBy = value;
    },
    openDetailsDialog(item) {
      this.selected = item;
      this.showDetails = true;
    },
    calculatePercentage(value, ref) {
      if (!ref) return 0;
      let percent = (value * 100) / ref;
      if (percent > 100) return 100;
      else if (percent < 0) return 0;
      else return parseInt(percent);
    },
    selectInfo(item) {
      let info = [];
      if (signal) {
        info.push(item.BAT + "V");
      }
      return info;
    },
    // ! Carregar opções dropdown
    loadFilterModels(ret) {
      this.loading = true;
      // this.clearSearch();

      let options = [];
      [...new Set(ret.map((obj) => obj.MODEL))].forEach((el) => {
        options.push({ text: el, value: el });
      });
      this.options = options;
      this.loading = false;
    },
  },
  computed: {
    updated() {
      return Object.keys(this.selected).length && this.selected.UPDATE
        ? this.formatUpdate(this.selected.UPDATE)
        : "";
    },
    variant() {
      return Object.keys(this.selected).length
        ? this.setBG(this.selected.RF && this.selected.RF.stat).split("-")[1]
        : "bg-grey";
    },
    validFilter() {
      return !!this.filter.split(" ").join("");
    },
    orderedList() {
      let filter = this.filterBy;
      let result = this.items;
      if (result.length > 0) {
        result = this.isActive(result);
      }
      this.alerts[0] = result.filter((item) => item.RF.stat == 0);
      this.alerts[7] = result.filter((item) => item.RF.stat == 7);
      this.alerts[8] = result.filter((item) => item.RF.stat == 8);
      this.alerts[9] = result.filter((item) => item.RF.stat == 9);
      if (
        this.isSearching &&
        this.validFilter &&
        result.length &&
        this.selectedRadiusButton == null
      ) {
        result = this.isSearch(result);
        this.alerts[0] = result.filter((item) => item.RF.stat == 0);
        this.alerts[7] = result.filter((item) => item.RF.stat == 7);
        this.alerts[8] = result.filter((item) => item.RF.stat == 8);
        this.alerts[9] = result.filter((item) => item.RF.stat == 9);
      }
      if (
        this.isSearching &&
        this.validFilter &&
        this.selectedRadiusButton !== null
      ) {
        result = this.isSearch(result);
        this.alerts[0] = result.filter((item) => item.RF.stat == 0);
        this.alerts[7] = result.filter((item) => item.RF.stat == 7);
        this.alerts[8] = result.filter((item) => item.RF.stat == 8);
        this.alerts[9] = result.filter((item) => item.RF.stat == 9);
        if (filter != 100) {
          if (this.mobile) {
            result = this.alerts[filter.value];
            try {
              if (!result.length) {
                this.showErrorNotSearch = true;
              } else {
                this.showErrorNotSearch = false;
              }
            } catch (error) {
              console.log("Result -> error :", error);
            }
          } else {
            result = this.isSearch(this.alerts[filter]);
            if (!result.length) {
              this.showErrorNotSearch = true;
            } else {
              this.showErrorNotSearch = false;
            }
          }
        }
      }
      // Estiver filtrando por comunicação
      else if (filter != 100) {
        if (this.mobile) {
          result = this.alerts[filter.value];
          try {
            if (!result.length) {
              this.showErrorNotSearch = true;
            } else {
              this.showErrorNotSearch = false;
            }
          } catch (error) {
            console.log("Result -> error :", error);
          }
        } else {
          result = this.isSearch(this.alerts[filter]);
          if (!result.length) {
            this.showErrorNotSearch = true;
          } else {
            this.showErrorNotSearch = false;
          }
        }
      }
      return result;
    },
  },
};
</script>

<style scoped>
.monitCard .info {
  line-height: 1.1em;
  display: flex;
  flex-direction: column;
  text-align: left;
}

.filter-model {
  max-height: 210px;
  overflow-y: auto;
  text-overflow: ellipsis;
  padding: 8px;
}
.monitCard .info .BAT {
  font-size: 1em;
  font-weight: 600;
  margin-bottom: 0.2em;
}
.BAT .material-design-icon {
  font-size: 1em;
  vertical-align: -0rem;
}
.monitCard .info .rssi {
  font-size: 0.8rem;
}
.percent-card {
  font-size: 1em;
  font-weight: 600;
}
.percent-card .material-design-icon {
  font-size: 0.85em;
  vertical-align: 1px;
}
@media screen and (max-width: 425px) {
  .monitCard {
    min-width: 89px !important;
  }
  .monitCard footer {
    width: 100%;
  }
  .monitCard footer #date {
    display: none;
  }
  .monitCard footer .status {
    width: 100%;
  }
}
@media screen and (max-width: 1170px) {
  .monitCard footer #date {
    font-weight: 600;
    font-size: 0.77em;
  }
}
</style>
